import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';
import { getModuleByName, getThumbnailFromRecommend } from '@src/common/utils';
import Divider from '@src/common/components/Divider';

const Grid = props => {
    const { content } = props;
    const articleList = getModuleByName(content, '英雄人生')?.data.articleList;

    return (
        <div>
            <Divider />
            <div className={Style.grid}>
                {articleList.map((article, index) => {
                    return (
                        <div className={Style.gridChildren} key={index}>
                            <img src={getThumbnailFromRecommend(article)} alt="" className={Style.itemImg} />
                            <div className={Style.mask}>
                                <a
                                    href={article.source === 'hide' ? '#!' : article.url}
                                    target={article.source === 'hide' ? '' : '_blank'}
                                    rel="noreferrer">
                                    <div className={article.maskText}>
                                        <div className={Style.title}>{article.title}</div>
                                        <div>{article.summary}</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
            <Divider />
        </div>
    );
};

Grid.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Grid);
